export default __webpack_public_path__ + "static/media/screen6.29d4b523.png";